import React, { useState, Fragment } from 'react';
import { createTheme, withStyles, ThemeProvider, makeStyles } from '@material-ui/core/styles';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MUIAccordion from '@material-ui/core/Accordion';
import clsx from 'clsx';
import MUITypography from '@material-ui/core/Typography';
import Button$1 from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import MUICard from '@material-ui/core/Card';
import { AspectRatio } from 'react-aspect-ratio';
import { Image, ChevronRight, ChevronLeft } from '@material-ui/icons';
import MUIGrid from '@material-ui/core/Grid';
import ParallaxSlide from '@mui-treasury/components/slide/parallax';
import Paper from '@material-ui/core/Paper';
import SportsEsports from '@material-ui/icons/SportsEsports';
import 'react-aspect-ratio/aspect-ratio.css';
import MUILink from '@material-ui/core/Link';
import { useControlled } from '@material-ui/core/utils';
import MUITable from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MUITabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import classNames from 'classnames';
import window from 'global';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var overridings = {
  themeName: 'AA Theme',
  palette: {
    primary: {
      main: '#DD271A'
    },
    secondary: {
      main: '#252525'
    },
    alternateTextColor: '#4a4a4a',
    canvasColor: '#616161',
    textColor: '#bdbdbd',
    secondaryTextColor: 'rgba(255, 255, 255, 0.54)',
    disabledColor: '#757575',
    accent1Color: '#DD271A'
  },
  typography: {
    fontFamily: ['Raleway', 'Arial', 'sans-serif'].join(','),
    h1: {
      fontSize: 70,
      fontWeight: 700
    },
    h2: {
      fontSize: 46,
      fontWeight: 700
    },
    h3: {
      fontSize: 34,
      fontWeight: 700
    },
    h4: {
      fontSize: 24,
      fontWeight: 700
    },
    body1: {
      fontSize: 16,
      lineHeight: '24px'
    },
    subtitle1: {
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: 700
    },
    caption: {
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: 300
    }
  },
  props: {
    MuiButton: {
      disableElevation: true
    }
  }
};
var theme = createTheme(overridings);
var _excluded$3 = ["classes", "children"];
var Typography = withStyles(function () {
  return {
    "default": {
      color: '#252525'
    }
  };
}, {
  withTheme: true
})(function (_ref) {
  var classes = _ref.classes,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/React.createElement(MUITypography, _extends({
    className: classes["default"]
  }, props), children);
});
function customStyles$a(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Typography, props));
}
var Accordion = withStyles(function (theme) {
  return {
    root: {
      width: '100%',
      textAlign: 'left'
    },
    accordion: {
      background: 'none',
      '&::before': {
        background: 'none'
      }
    },
    heading: {
      fontSize: '14px',
      fontWeight: '700',
      color: '#DD271A'
    },
    inactive: {
      color: '#000'
    },
    summary: {
      padding: '0',
      borderBottom: '1px solid #dddddd'
    },
    accordionDetails: {
      padding: '24px 0 0'
    }
  };
}, {
  withTheme: true
})(function (_ref) {
  var classes = _ref.classes,
    data = _ref.data;
  var _React$useState = React.useState(-1),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    expanded = _React$useState2[0],
    setExpanded = _React$useState2[1];
  var handleChange = function handleChange(panel) {
    return function (e, isExpanded) {
      setExpanded(isExpanded ? panel : false);
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, data.map(function (_ref2, index) {
    var _ref3 = _slicedToArray(_ref2, 2),
      title = _ref3[0],
      body = _ref3[1];
    var isActive = expanded === index + 1;
    return /*#__PURE__*/React.createElement(MUIAccordion, {
      expanded: expanded === index + 1,
      onChange: handleChange(index + 1),
      elevation: 0,
      className: isActive ? classes.accordion : clsx(classes.accordion, classes.inactive),
      key: "AC-".concat(index)
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.summary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
      IconButtonProps: {
        color: isActive ? 'primary' : '#000'
      },
      "aria-controls": "panel".concat(index, "bh-content"),
      id: "panel".concat(index, "bh-header")
    }, /*#__PURE__*/React.createElement(customStyles$a, {
      className: isActive ? classes.heading : clsx(classes.heading, classes.inactive)
    }, title)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(customStyles$a, null, body)));
  }));
});
function customStyles$9(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Accordion, props));
}
var Button = withStyles(function (theme) {
  return {
    mainCta: {
      minHeight: 36,
      borderRadius: 0
    },
    secondaryCta: {
      minHeight: 36,
      borderWidth: "2px !important",
      borderRadius: 0,
      color: 'black'
    },
    secondaryPrimaryCta: {
      borderColor: '#DD271A',
      '&:hover': {
        backgroundColor: '#DD271A',
        color: '#fff !important'
      }
    },
    secondaryWhiteCta: {
      borderWidth: '2px !important',
      borderColor: '#000 !important',
      backgroundColor: '#fff !important',
      color: '#000 !important',
      '&:hover': {
        borderColor: '#fff !important',
        backgroundColor: '#000 !important',
        color: '#fff !important'
      }
    },
    standSecondCta: {
      borderColor: '#252525',
      '&:hover': {
        backgroundColor: '#000',
        color: '#fff'
      }
    },
    typography: {
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: 1.01
    },
    underline: {
      height: 2,
      backgroundColor: theme.palette.primary.main
    },
    outlinedTypography: {
      fontSize: 16,
      fontWeight: 700,
      letterSpacing: 1.01
    }
  };
}, {
  withTheme: true
})(function (_ref) {
  var classes = _ref.classes,
    variant = _ref.variant,
    label = _ref.label,
    color = _ref.color,
    onClick = _ref.onClick,
    href = _ref.href,
    className = _ref.className;
  var buttonClassName;
  var spanClassName;
  switch (variant) {
    case 'contained':
      buttonClassName = clsx(classes.mainCta, className);
      spanClassName = classes.typography;
      break;
    case 'outlined':
      if (color === 'primary') {
        buttonClassName = clsx(classes.secondaryCta, classes.secondaryPrimaryCta, className);
      } else if (color === 'white') {
        buttonClassName = clsx(classes.secondaryCta, classes.secondaryWhiteCta, className);
      } else {
        buttonClassName = clsx(classes.secondaryCta, classes.standSecondCta, className);
      }
      spanClassName = classes.outlinedTypography;
      break;
  }
  return /*#__PURE__*/React.createElement(Button$1, {
    color: color,
    variant: variant,
    onClick: onClick,
    className: buttonClassName,
    href: href,
    disableRipple: true
  }, /*#__PURE__*/React.createElement("span", {
    className: spanClassName
  }, label));
});
function customStyles$8(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Button, props));
}
var Placeholder = withStyles({
  root: {
    flexGrow: 1,
    maxWidth: 1280
  },
  placeholderBackground: {
    backgroundColor: '#bcbebe'
  },
  placeholderIcon: {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    color: '#ffffff',
    fontSize: 48
  }
}, {
  withTheme: true
})(function (_ref) {
  var classes = _ref.classes;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.placeholderBackground
  }, /*#__PURE__*/React.createElement(Image, {
    className: classes.placeholderIcon
  }));
});
var Card = withStyles(function (theme) {
  var _content;
  return {
    mediaContainer: {
      zIndex: 20,
      maxWidth: '420px',
      width: '100%',
      '@media (min-width: 992px)': {
        "float": 'right'
      },
      '@media (max-width: 768px)': {
        width: 'unset',
        maxWidth: 'unset',
        padding: '15px'
      }
    },
    media: {
      // width: '100%',
      // height: 0,
      // paddingBottom: '75%',
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      zIndex: 10
    },
    button: {
      marginTop: '20px',
      padding: '8px'
    },
    root: {
      overflow: 'initial',
      backgroundColor: 'transparent',
      display: 'flex',
      padding: '60px 35px 60px 0',
      maxWidth: '1170px',
      textAlign: 'left',
      '@media (max-width: 768px)': {
        display: 'flex',
        flexDirection: function flexDirection(props) {
          return props.rightAligned ? 'column-reverse' : 'column';
        },
        padding: 'unset'
      }
    },
    center: {
      justifyContent: 'center',
      margin: '0 auto',
      maxWidth: 1170
    },
    content: (_content = {
      position: 'relative',
      backgroundColor: '#f2f5f9',
      borderRadius: 4,
      margin: '-60px -50px',
      padding: function padding(props) {
        return props.rightAligned ? '60px 75px 60px 50px' : '60px 50px 60px 75px';
      },
      width: 'calc(100% - 125px)',
      zIndex: 15
    }, _defineProperty(_content, theme.breakpoints.down('lg'), {// Styles for when viewport is below 1280px - breakpoint for collapsing of content
      // backgroundColor: "#00FF00",
    }), _defineProperty(_content, theme.breakpoints.up('lg'), {// Styles for when viewport is above 1280px
      // backgroundColor: "#f2f5f9",
    }), _defineProperty(_content, '@media (max-width: 768px)', {
      margin: '-60px 0',
      width: 'unset',
      padding: '60px 15px !important'
    }), _content),
    cardWrapper: {
      position: 'relative'
    },
    altContent: {
      backgroundColor: 'transparent'
    },
    bgLayout: {
      position: 'absolute',
      top: 0,
      right: function right(props) {
        return props.rightAligned ? 'unset' : 0;
      },
      left: function left(props) {
        return props.rightAligned ? 0 : 'unset';
      },
      width: '35%',
      height: '100%',
      backgroundColor: '#f2f5f9',
      '@media (max-width: 768px)': {
        display: 'none'
      }
    }
  };
}, {
  withTheme: true
})(function (_ref) {
  var classes = _ref.classes,
    center = _ref.center,
    image = _ref.image,
    title = _ref.title,
    type = _ref.type,
    alt = _ref.alt,
    children = _ref.children,
    buttonText = _ref.buttonText,
    onClick = _ref.onClick,
    rightAligned = _ref.rightAligned;
  var MediaContainer = function MediaContainer() {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.mediaContainer
    }, /*#__PURE__*/React.createElement(AspectRatio, {
      ratio: "4/3"
    }, image ? /*#__PURE__*/React.createElement(CardMedia, {
      alt: alt,
      image: image,
      className: classes.media
    }) : /*#__PURE__*/React.createElement(Placeholder, null)));
  };
  var Content = function Content() {
    return /*#__PURE__*/React.createElement(CardContent, {
      className: type !== 'alt' ? "".concat(classes.content, " ").concat(classes.altContent) : classes.content
    }, /*#__PURE__*/React.createElement(customStyles$a, {
      gutterBottom: true,
      variant: "h3"
    }, title), /*#__PURE__*/React.createElement(customStyles$a, {
      variant: "body1",
      color: "textSecondary"
    }, children ? children : /*#__PURE__*/React.createElement("span", null, "In the Online Teaching Library, you can find all the resources for online instructors, including: ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "\u2022 a blog about online teaching ", /*#__PURE__*/React.createElement("br", null), "\u2022 a schedule of upcoming online workshops and links to recording of past workshops ", /*#__PURE__*/React.createElement("br", null), "\u2022 supplemental teaching materials, including tutorials, checklists, cheat-sheets, sample files, and more ", /*#__PURE__*/React.createElement("br", null), "\u2022 online teaching FAQ where you can also ask questions ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "Log in with your AAU username and password.")), buttonText && /*#__PURE__*/React.createElement(customStyles$8, {
      className: classes.button,
      variant: "outlined",
      label: type !== 'alt' ? buttonText.toUpperCase() : buttonText,
      color: type !== 'alt' ? 'secondary' : 'primary',
      onClick: onClick
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.cardWrapper
  }, /*#__PURE__*/React.createElement(MUICard, {
    className: clsx(classes.root, center && classes.center),
    elevation: 0
  }, rightAligned ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Content, null), /*#__PURE__*/React.createElement(MediaContainer, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaContainer, null), /*#__PURE__*/React.createElement(Content, null)), /*#__PURE__*/React.createElement(CardActions, null)), type === 'alt' && /*#__PURE__*/React.createElement("div", {
    className: classes.bgLayout
  }));
});
function customStyles$7(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Card, props));
}
var DetailsCard = withStyles({
  mediaContainer: {
    zIndex: 1,
    width: '100%',
    marginTop: '-5em'
  },
  media: {
    backgroundColor: '#dfe2e6',
    zIndex: 1
  },
  root: {
    overflow: 'initial',
    maxWidth: '420px',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    backgroundColor: '#f2f5f9',
    padding: '1em',
    marginTop: '100px'
  },
  content: {
    position: 'relative',
    padding: '1em 0 0',
    paddingBottom: '8px !important'
  },
  altContent: {
    backgroundColor: 'transparent'
  },
  title: {
    fontWeight: 'bold',
    color: '#252525'
  },
  buttonContainer: {
    margin: '2em auto 0',
    textAlign: 'center'
  },
  buttonPlaceholder: {
    height: 36
  },
  iframeContainer: {
    zIndex: 1
  }
}, {
  withTheme: true
})(function (_ref) {
  var classes = _ref.classes,
    image = _ref.image,
    title = _ref.title,
    alt = _ref.alt,
    children = _ref.children,
    buttonText = _ref.buttonText,
    onClick = _ref.onClick,
    href = _ref.href,
    iframe = _ref.iframe,
    iframeProps = _ref.iframeProps;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    videoEnabled = _useState2[0],
    setVideoEnabled = _useState2[1];
  var toggleVideo = function toggleVideo() {
    return setVideoEnabled(!videoEnabled);
  };
  var showImage = image && !videoEnabled;
  var showVideo = iframe && videoEnabled;
  return /*#__PURE__*/React.createElement(MUICard, {
    className: classes.root,
    elevation: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mediaContainer
  }, /*#__PURE__*/React.createElement(AspectRatio, {
    ratio: "4/3"
  }, showImage && /*#__PURE__*/React.createElement(CardMedia, {
    alt: alt,
    image: image,
    className: classes.media
  }), showVideo && /*#__PURE__*/React.createElement(CardMedia, _extends({
    className: classes.iframeContainer,
    component: "iframe",
    image: iframe
  }, iframeProps)), /*#__PURE__*/React.createElement(Placeholder, null))), /*#__PURE__*/React.createElement(CardContent, {
    className: clsx(classes.content)
  }, /*#__PURE__*/React.createElement(customStyles$a, {
    gutterBottom: true,
    variant: "h6",
    className: classes.title
  }, title), children && /*#__PURE__*/React.createElement(customStyles$a, {
    variant: "body1",
    color: "textSecondary"
  }, children), buttonText ? /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(customStyles$8, {
    variant: "outlined",
    label: buttonText,
    color: "primary",
    onClick: iframe ? toggleVideo : onClick,
    center: true,
    href: !iframe && href ? href : null
  })) : /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.buttonPlaceholder
  }))));
});
var ShortCard = withStyles({
  link: {
    textDecoration: 'none'
  },
  mediaContainer: {
    zIndex: 1,
    width: '100%'
  },
  media: {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    zIndex: 1
  },
  root: {
    overflow: 'initial',
    backgroundColor: 'transparent',
    maxWidth: '420px',
    textAlign: 'left'
  },
  content: {
    position: 'relative',
    backgroundColor: '#f2f5f9',
    borderRadius: 4,
    margin: '-24% 16px 0',
    zIndex: 2
  },
  altContent: {
    backgroundColor: 'transparent'
  }
}, {
  withTheme: true
})(function (_ref2) {
  var classes = _ref2.classes,
    image = _ref2.image,
    title = _ref2.title,
    alt = _ref2.alt,
    date = _ref2.date,
    href = _ref2.href;
  return /*#__PURE__*/React.createElement("a", {
    href: href ? href : '#',
    className: classes.link
  }, /*#__PURE__*/React.createElement(MUICard, {
    className: classes.root,
    elevation: 0
  }, /*#__PURE__*/React.createElement(AspectRatio, {
    ratio: "4/3"
  }, image && /*#__PURE__*/React.createElement(CardMedia, {
    alt: alt,
    image: image,
    className: classes.media
  }), /*#__PURE__*/React.createElement(Placeholder, null)), /*#__PURE__*/React.createElement(CardContent, {
    className: classes.content
  }, /*#__PURE__*/React.createElement(customStyles$a, {
    gutterBottom: true,
    variant: "h6"
  }, title), date && /*#__PURE__*/React.createElement(customStyles$a, {
    variant: "body1",
    color: "textSecondary"
  }, date))));
});
var useStyles$4 = makeStyles({
  root: {
    flexGrow: 1,
    maxWidth: 1280
  }
});
function customStyles$6(props) {
  var classes = useStyles$4();
  var data = props.data,
    type = props.type;
  var size = {
    md: data.length === 1 ? 12 : data.length === 2 ? 6 : 4,
    sm: data.length === 1 ? 12 : 6,
    xs: 12
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(MUIGrid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(MUIGrid, {
    container: true,
    justifyContent: "flex-start",
    spacing: 3
  }, data && data.map(function (card, idx) {
    var children = /*#__PURE__*/React.createElement(DetailsCard, _extends({
      key: "details-card-".concat(idx)
    }, card));
    if (type === 'short') {
      children = /*#__PURE__*/React.createElement(ShortCard, _extends({
        key: "short-card-".concat(idx)
      }, card));
    }
    return /*#__PURE__*/React.createElement(MUIGrid, {
      key: idx,
      item: true,
      xs: size.xs,
      sm: size.sm,
      md: size.md
    }, children);
  }))));
}
var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAABWCAMAAABLj25CAAAAAXNSR0IB2cksfwAAAdpQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////DsSUuAAAAJ50Uk5TABBh8z4Mqf/nETPfAXn7F75G6wWQI9D205YH7kvDGfx+AuI4ka8P9WVi9NQnk3pj/o/6d5JejOh7uRQawXPA7d0ylKEKX1Y2yiGw3Kq9/eBJTR/FgASeswtr2D/s70IddK18HEooabuijscVW/nmLzXl+FcWAwakwnArTCDXg7iBT/EseAk9OulszgjMdURdJNsOtROG41X3UjHENGgguk/YAAACpklEQVR4nJ3W+V8SQRgG8AnCCSVESSw8CElIQSKyS8suKrusLDuUsrustFM7zbL7Pu2y/tfk47yza+wsO8/74+5+2WWfnXdexsCah8JCudzzYesp43yBF8TlFXy2AOtb6OewrgxwDuuqag7r4CLOYV0T4rh21RJbrK0LIYtaEtbVMmReV8+YnjaF3NDINLURcmRplGlqI+Sm2OwR5zq4TL6u5jjT1EbIieXyoFPd0ko4mTKOOtOmkNvCpuOOdGxOyHo6mp4bspZubCDrT0f/O1dS19cRrogVnSyhw0bIZZ7i0/Y6lSTb2mJ13lavSBAO1VheYKPjzWQzK4PWP6/WsSbC1VWKZ1NqU8iBShVWaSPk7CqfEiu0KeRytbXW4XbbkO21EbJ7ta210iVDttGmkNcoQlZrI+S1ypBVOrpOhry+wwE26Tjr3CDf9UYn1qy7ApvIbt7iDBt6q7wv35ZziGVtl9a9Q9eynRJ379LGbDfhPfqWsdxe4vug4THdI/j+VOmLi+sAjSPugwjvPURPfxjhfUeIHz2G+OP0nff3InwgL/iJkwgfFBMcj5xCeE5+OKfDpa8urjMZwUNnEX7OLXi+eM91UOdp0sheQLj3Iv35S30Ajw4Rv3wFuf3VYcFHriH8+g3Bb95C+O1uevqhUYCP3SF+F2oZ9yLUMu4jfIA28toHCH84Lnjmkc0MoSyPXDUTUMt4TKumv+R+blVPEoJPQi3jKa2anmcI93bJlvEc4KNtxJNQy3BRu82/QPjLV4L7XyO8841sGWMAfys32ndQy3hPG+2I7fiqqg+Tgg9/RPinz/T07UjL+PJVtoxvAPdNEf8OtYwfP6ll/EL4bzkLTyEto2Oa+B/k7jSkQCt2pv5mC+sVxDOrJs/HtcdhowanRZ/7B10xY8EFz8xdAAAAAElFTkSuQmCC";
var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAABWCAMAAABLj25CAAAAAXNSR0IB2cksfwAAAYNQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////Gk++nAAAAIF0Uk5TAAiFmv/YK4CRbLQR5jz9gwPHHfBQ9Jkj0AWQ+EbrF74BePsz3wypYPOO/nX6XfLMBItB6BS5cvkv3AqgViCIcEAw3fcynRXxxN6ffQmzuA4f1IZD/EcHqBk46oT2TJjgwhCPVwKNvSeiaILsCxxCc3bvrT1+awZS4xOTbTftP9dLWiUmugAAAmtJREFUeJyl1/lXElEcBfBrDmpFKJGB0TJKi6kkWSkS2qJhi3uKS5oappRLZeXS/qcHOd+n5gzz7vD9kXM+5zvn3TOXNwBQcaIC3qfS8FV5pNXVNUZhTnrThjWnTpejDf+ZcrQRqK0rQxtG8Gw52gid86TrxZ/not9H4YhwLvp9g4YLwqNM9JYGLl7yEL3SuHyFj/5Aw2xsYqM/pIHYVTL6IxrXrnPRH9XAjWbxlRrR/69BRX9Mo+Fmi3b0xzUTvZ3Wj95Ww2xt04reXutG76T1onfUQPyWa/QlNMLtbtGX0kjcdom+pAY67pSM3kXj7r1S0btpoLPLOXp3jWS3Y/QaGqn7TtHraCDt8NbrafTYR6+pkei1i15X20evr+2iJzTwQLhR25Eu/vDw32hqPHqsfF+/LjqY1BPF/RmeIz0g/KkHjZ5nwp970C8k+O4wbQeHZPPwCI1HxwSPmzR+GRLcSlt0Tlh2YJK22SnD+3lNR8o4r5lZwa9MGsflRjQ3T9vEa1m8wH9GZIKCF5donPQLfsNf4XNRy0ZztF1+q17oJI2XVgQH+TZYXRCcT9B4Xj4a2t7R1nwvRbA2Q+P1YXnqyAaNwz7BU1kab0p3TnygLT4GLPxpk7bZLXlq3yiNN1QRDK3T+POaZVu+0BZfpQjq+e7bzqvuW6VxRl1QVvjui6ki6F2mcU7uhdEd2tbVyOJdvgj2FlX37dG4alfwN777duYs2xWnrTkui2djNB5RRdA+TeOwuoHnt2k8KUXQ9J22+CGLf/7iMWBVwRjffcVJ/S7irUFPuHBqzUag0aMtzJ8Q332Hhv9TL85f8ZZQWMNd2WcAAAAASUVORK5CYII=";
var Carousel = withStyles(function (theme) {
  var _arrow;
  return {
    root: {
      // a must if you want to set arrows, indicator as absolute
      position: 'relative',
      width: '100%',
      maxWidth: 1280
    },
    slide: {
      perspective: 1000,
      // create perspective
      overflow: 'hidden',
      // relative is a must if you want to create overlapping layers in children
      position: 'relative'
    },
    imageContainer: {
      margin: 0,
      display: 'block',
      overflow: 'hidden',
      position: 'relative',
      zIndex: 2,
      paddingBottom: '56.25%'
    },
    image: _defineProperty({
      display: 'block',
      padding: '1.6rem 0',
      position: 'absolute',
      zIndex: 10,
      width: '76%',
      height: '100%',
      objectFit: 'contain',
      margin: '0 12%'
    }, theme.breakpoints.up('sm'), {
      margin: '0 4%',
      width: '92%'
    }),
    caption: {
      textAlign: 'center'
    },
    icon: {
      width: 21,
      height: 29
    },
    arrow: (_arrow = {
      display: 'inline-flex',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 60,
      height: 60
    }, _defineProperty(_arrow, theme.breakpoints.down('sm'), {
      top: '40%',
      minWidth: '40px !important',
      maxWidth: '40px !important',
      height: 40
    }), _defineProperty(_arrow, "backgroundColor", '#DD271A'), _defineProperty(_arrow, "border", 0), _defineProperty(_arrow, "borderRadius", 0), _defineProperty(_arrow, '&:hover', {
      backgroundColor: '#ce1c0d'
    }), _arrow),
    arrowLeft: {
      left: 0
    },
    arrowRight: {
      right: 0
    },
    indicatorContainer: {
      textAlign: 'center'
    }
  };
}, {
  withTheme: true
})(function (_ref) {
  var classes = _ref.classes,
    data = _ref.data; // eslint-disable-next-line react/prop-types

  var renderElements = function renderElements(_ref2) {
    var index = _ref2.index,
      onChangeIndex = _ref2.onChangeIndex;
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button$1, {
      className: clsx(classes.arrow, classes.arrowLeft) // disabled={index === 0}
      ,

      disableRipple: true,
      onClick: function onClick() {
        return onChangeIndex(index !== 0 ? index - 1 : data.length - 1);
      }
    }, /*#__PURE__*/React.createElement("img", {
      className: classes.icon,
      alt: "Arrow Left",
      src: img$1
    })), /*#__PURE__*/React.createElement(Button$1, {
      className: clsx(classes.arrow, classes.arrowRight) // disabled={index === data.length - 1}
      ,

      disableRipple: true,
      onClick: function onClick() {
        return onChangeIndex(index !== data.length - 1 ? index + 1 : 0);
      }
    }, /*#__PURE__*/React.createElement("img", {
      className: classes.icon,
      alt: "Arrow Right",
      src: img
    })));
  };
  var renderChildren = function renderChildren() {
    return data.map(function (_ref3, i) {
      var id = _ref3.id,
        alt = _ref3.alt,
        image = _ref3.image,
        caption = _ref3.caption;
      return /*#__PURE__*/React.createElement("div", {
        key: id,
        className: classes.slide
      }, /*#__PURE__*/React.createElement("div", {
        role: "figure",
        className: classes.imageContainer,
        "aria-labelledby": "caption"
      }, /*#__PURE__*/React.createElement("img", {
        className: classes.image,
        src: image,
        alt: alt
      })), caption && /*#__PURE__*/React.createElement("p", {
        id: "caption",
        className: clsx(theme.typography.caption, classes.caption)
      }, caption));
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(ParallaxSlide, {
    renderElements: renderElements
  }, renderChildren));
});
function customStyles$5(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Carousel, props));
}
var ImageGrid = withStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      maxWidth: 1280
    },
    paper: {
      maxHeight: 400,
      maxWidth: 420,
      width: '100%',
      background: 'none',
      textAlign: 'left'
    },
    control: {
      padding: theme.spacing(2)
    },
    img: {
      objectFit: 'cover',
      backgroundColor: '#bcbebe',
      zIndex: 2
    },
    title: {
      fontSize: 16,
      fontWeight: 700
    },
    tileTitleContainer: _defineProperty({
      backgroundColor: '#FFF',
      display: 'flex',
      padding: '0.5rem 1rem',
      flexBasis: '60%',
      textAlign: 'left'
    }, theme.breakpoints.up('sm'), {
      backgroundColor: 'unset',
      padding: 0,
      bottom: 0,
      zIndex: 2,
      position: 'absolute',
      justifyContent: 'space-between',
      width: '100%'
    }),
    tileTitle: _defineProperty({
      backgroundColor: '#FFF',
      fontWeight: 'bold',
      fontSize: '1rem',
      lineHeight: '2rem',
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      padding: '0 0.5rem',
      fontSize: 14,
      width: 'auto'
    }),
    tileGameIndicator: _defineProperty({
      backgroundColor: '#000',
      color: '#FFF',
      right: 0,
      padding: '5px 5px 0',
      bottom: 0,
      position: 'absolute'
    }, theme.breakpoints.up('sm'), {
      backgroundColor: '#FFF',
      color: '#000',
      padding: '0 0.5rem',
      display: 'flex',
      alignItems: 'center',
      position: 'unset'
    }),
    tileImage: _defineProperty({}, theme.breakpoints.down('sm'), {
      flexBasis: '40%'
    }),
    tileWrapper: {
      position: 'relative',
      '@media (max-width: 600px)': {
        display: 'flex'
      }
    },
    body: {
      fontSize: 16
    },
    nonDefaultLink: {
      textDecoration: 'none'
    },
    link: {
      cursor: 'pointer',
      color: '#e72112',
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  };
}, {
  withTheme: true
})(function (_ref) {
  var classes = _ref.classes,
    data = _ref.data,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _onClick = _ref.onClick;
  var size = {
    md: data.length === 1 ? 12 : data.length === 2 ? 6 : data.length === 3 ? 4 : 3,
    sm: data.length === 1 ? 12 : data.length === 2 ? 6 : 4,
    xs: data.length === 1 ? 12 : 6
  };
  var ratio = data.length === 1 ? '2/1' : data.length === 2 ? '6/4' : '4/3';
  var MasterLink = function MasterLink(_ref2) {
    var children = _ref2.children,
      href = _ref2.href,
      variant = _ref2.variant;
    if (!href) {
      return /*#__PURE__*/React.createElement("div", {
        className: variant === 'tile' ? classes.tileWrapper : ''
      }, children);
    }
    return /*#__PURE__*/React.createElement("a", {
      href: href,
      className: classes.link,
      onClick: function onClick(e) {
        e.preventDefault();
        _onClick(href);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.tileWrapper
    }, children));
  };
  return /*#__PURE__*/React.createElement(MUIGrid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(MUIGrid, {
    container: true,
    justifyContent: "flex-start",
    spacing: 3
  }, data.map(function (_ref3, idx) {
    var _ref4 = _slicedToArray(_ref3, 4),
      image = _ref4[0],
      title = _ref4[1],
      body = _ref4[2],
      children = _ref4[3];
    var isHref = Array.isArray(title) ? title[1] : null;
    var isGame = Array.isArray(title) ? title[2] : null;
    return /*#__PURE__*/React.createElement(MUIGrid, {
      key: idx,
      item: true,
      xs: variant === 'default' ? size.sm : 12,
      sm: variant === 'default' ? size.sm : 6,
      md: size.md
    }, /*#__PURE__*/React.createElement(MasterLink, {
      href: isHref,
      variant: variant
    }, /*#__PURE__*/React.createElement(AspectRatio, {
      ratio: ratio,
      className: variant === 'default' ? '' : classes.tileImage
    }, image && /*#__PURE__*/React.createElement("img", {
      alt: "complex",
      loading: "lazy",
      src: image,
      className: classes.img
    }), /*#__PURE__*/React.createElement(Placeholder, null)), variant === 'default' ? /*#__PURE__*/React.createElement(Paper, {
      className: classes.paper,
      elevation: 0
    }, Array.isArray(title) ? /*#__PURE__*/React.createElement(customStyles$a, {
      className: [classes.title, classes.nonDefaultLink],
      color: "primary"
    }, title[0]) : /*#__PURE__*/React.createElement(customStyles$a, {
      className: classes.title,
      color: "secondary"
    }, title)) : isGame ? /*#__PURE__*/React.createElement("div", {
      className: classes.tileTitleContainer
    }, /*#__PURE__*/React.createElement(customStyles$a, {
      className: classes.tileTitle,
      color: "secondary"
    }, Array.isArray(title) ? title[0] : title), /*#__PURE__*/React.createElement("div", {
      className: classes.tileGameIndicator
    }, /*#__PURE__*/React.createElement(SportsEsports, null))) : /*#__PURE__*/React.createElement("div", {
      className: classes.tileTitleContainer
    }, /*#__PURE__*/React.createElement(customStyles$a, {
      className: classes.tileTitle,
      color: "secondary"
    }, Array.isArray(title) ? title[0] : title))), variant === 'default' && /*#__PURE__*/React.createElement(Paper, {
      className: classes.paper,
      elevation: 0
    }, /*#__PURE__*/React.createElement(customStyles$a, {
      className: classes.body,
      color: "secondary"
    }, body)), children);
  })));
});
function customStyles$4(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(ImageGrid, props));
}
var _excluded$2 = ["classes", "variant", "label"];
var Link = withStyles(function (theme) {
  return {
    ctaLinkButton: {
      borderBottom: '2px solid red',
      borderBottomColor: theme.palette.primary,
      borderRadius: 0
    },
    ctaLink: {
      fontWeight: 700,
      borderBottom: '2px solid red',
      borderBottomColor: theme.palette.primary,
      textTransform: 'uppercase',
      textDecoration: 'none',
      '&:hover': {
        color: '#000',
        textDecoration: 'none',
        borderBottomColor: '#000'
      }
    },
    standardLink: {
      textTransform: 'none'
    }
  };
}, {
  withTheme: true
})(function (_ref) {
  var classes = _ref.classes,
    variant = _ref.variant,
    label = _ref.label,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/React.createElement(MUILink, _extends({
    color: "primary",
    className: variant === 'cta' && classes.ctaLink
  }, rest), label);
});
function customStyles$3(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Link, props));
}
var _excluded$1 = ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"];
function usePagination() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // keep default values in sync with @default tags in Pagination.propTypes

  var _props$boundaryCount = props.boundaryCount,
    boundaryCount = _props$boundaryCount === void 0 ? 1 : _props$boundaryCount,
    _props$componentName = props.componentName,
    componentName = _props$componentName === void 0 ? 'usePagination' : _props$componentName,
    _props$count = props.count,
    count = _props$count === void 0 ? 1 : _props$count,
    _props$defaultPage = props.defaultPage,
    defaultPage = _props$defaultPage === void 0 ? 1 : _props$defaultPage,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$hideNextButton = props.hideNextButton,
    hideNextButton = _props$hideNextButton === void 0 ? false : _props$hideNextButton,
    _props$hidePrevButton = props.hidePrevButton,
    hidePrevButton = _props$hidePrevButton === void 0 ? false : _props$hidePrevButton,
    handleChange = props.onChange,
    pageProp = props.page,
    _props$showFirstButto = props.showFirstButton,
    showFirstButton = _props$showFirstButto === void 0 ? false : _props$showFirstButto,
    _props$showLastButton = props.showLastButton,
    showLastButton = _props$showLastButton === void 0 ? false : _props$showLastButton,
    _props$siblingCount = props.siblingCount,
    siblingCount = _props$siblingCount === void 0 ? 1 : _props$siblingCount,
    other = _objectWithoutProperties(props, _excluded$1);
  var _useControlled = useControlled({
      controlled: pageProp,
      "default": defaultPage,
      name: componentName,
      state: 'page'
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    page = _useControlled2[0],
    setPageState = _useControlled2[1];
  var handleClick = function handleClick(event, value) {
    if (!pageProp) {
      setPageState(value);
    }
    if (handleChange) {
      handleChange(event, value);
    }
  }; // https://dev.to/namirsab/comment/2050

  var range = function range(start, end) {
    var length = end - start + 1;
    return Array.from({
      length: length
    }, function (_, i) {
      return start + i;
    });
  };
  var startPages = range(1, Math.min(boundaryCount, count));
  var endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
  var siblingsStart = Math.max(Math.min(
  // Natural start
  page - siblingCount,
  // Lower boundary when page is high
  count - boundaryCount - siblingCount * 2 - 1),
  // Greater than startPages
  boundaryCount + 2);
  var siblingsEnd = Math.min(Math.max(
  // Natural end
  page + siblingCount,
  // Upper boundary when page is low
  boundaryCount + siblingCount * 2 + 2),
  // Less than endPages
  endPages[0] - 2); // Basic list of items to render
  // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']

  var itemList = [].concat(_toConsumableArray(showFirstButton ? ['first'] : []), _toConsumableArray(hidePrevButton ? [] : ['previous']), _toConsumableArray(startPages), _toConsumableArray(siblingsStart > boundaryCount + 2 ? ['start-ellipsis'] : boundaryCount + 1 < count - boundaryCount ? [boundaryCount + 1] : []), _toConsumableArray(range(siblingsStart, siblingsEnd)), _toConsumableArray(siblingsEnd < count - boundaryCount - 1 ? ['end-ellipsis'] : count - boundaryCount > boundaryCount ? [count - boundaryCount] : []), _toConsumableArray(endPages), _toConsumableArray(hideNextButton ? [] : ['next']), _toConsumableArray(showLastButton ? ['last'] : [])); // Map the button type to its page number

  var buttonPage = function buttonPage(type) {
    switch (type) {
      case 'first':
        return 1;
      case 'previous':
        return page - 1;
      case 'next':
        return page + 1;
      case 'last':
        return count;
      case 'start-ellipsis':
        return 1;
      case 'end-ellipsis':
        return count;
      default:
        return null;
    }
  }; // Convert the basic item list to PaginationItem props objects

  var items = itemList.map(function (item) {
    return typeof item === 'number' ? {
      onClick: function onClick(event) {
        handleClick(event, item);
      },
      type: 'page',
      page: item,
      selected: item === page,
      disabled: disabled,
      'aria-current': item === page ? 'true' : undefined
    } : {
      onClick: function onClick(event) {
        handleClick(event, buttonPage(item));
      },
      type: item,
      page: buttonPage(item),
      selected: false,
      disabled: disabled || item.indexOf('ellipsis') === -1 && (item === 'next' || item === 'last' ? page >= count : page <= 1)
    };
  });
  return _objectSpread2({
    items: items
  }, other);
}
var _excluded = ["page", "type", "selected"];
var Pagination = withStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      alignContent: 'center',
      justifyContent: 'center',
      padding: '4em 1em 4em 1em'
    },
    wrapper: {
      display: 'flex',
      height: '38px'
    },
    paginationItem: {
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 700,
      width: '38px',
      height: '100%',
      marginRight: '5px',
      border: '2px solid #f12f15',
      cursor: 'pointer',
      color: '#252525',
      fontFamily: ['Raleway', 'Arial', 'sans-serif'].join(','),
      fontSize: '12px',
      '&:hover': {
        backgroundColor: '#DD271A',
        color: '#fff'
      }
    },
    disabled: {
      opacity: 0.5,
      backgroundColor: '#f12f15',
      color: 'white',
      display: 'none'
    },
    paginationItemActive: {
      backgroundColor: '#f12f15',
      border: 'transparent',
      color: '#FFF'
    }
  };
}, {
  withTheme: true
})(function (_ref) {
  var classes = _ref.classes,
    pages = _ref.pages,
    onClick = _ref.onClick;
  var _usePagination = usePagination({
      count: pages,
      defaultPage: 1
    }),
    items = _usePagination.items;
  return /*#__PURE__*/React.createElement("nav", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("ul", {
    className: classes.wrapper
  }, items.map(function (_ref2, index) {
    var page = _ref2.page,
      type = _ref2.type,
      selected = _ref2.selected,
      item = _objectWithoutProperties(_ref2, _excluded);
    var children = null;
    if (selected === true) {
      onClick(page); // TODO: Fix with ellipses
    }

    if (type === 'start-ellipsis' || type === 'end-ellipsis') {
      children = /*#__PURE__*/React.createElement("span", null, "...");
    } else if (type === 'next') {
      children = /*#__PURE__*/React.createElement(ChevronRight, null);
    } else if (type === 'previous') {
      children = /*#__PURE__*/React.createElement(ChevronLeft, null);
    } else if (type === 'page') {
      children = /*#__PURE__*/React.createElement("div", {
        style: {
          fontWeight: selected ? 'bold' : undefined
        }
      }, page);
    }
    var shouldBeDisabled = page === 0 || page === pages + 1;
    return /*#__PURE__*/React.createElement("li", _extends({
      className: selected ? "".concat(classes.paginationItem, " ").concat(classes.paginationItemActive) : shouldBeDisabled ? "".concat(classes.paginationItem, " ").concat(classes.disabled) : classes.paginationItem,
      key: index
    }, item), children);
  })));
});
function customStyles$2(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Pagination, props));
}
var StyledTableCell = withStyles(function (theme) {
  return {
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      fontSize: 14,
      fontWeight: 700,
      '& a': {
        textDecoration: 'underline',
        color: theme.palette.common.white
      }
    },
    body: {
      color: '#000',
      fontSize: 14
    }
  };
})(TableCell);
var StyledTableRow = withStyles(function (theme) {
  return {
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover // backgroundColor: '#f8f8f8',
      },

      '&:nth-of-type(even)': {
        // backgroundColor: theme.palette.action.hover,
        backgroundColor: '#fff'
      },
      '& a': {
        textDecoration: 'underline',
        color: '#EE3224'
      }
    }
  };
})(TableRow);
var Table = withStyles(function (theme) {
  return {};
}, {
  withTheme: true
})(function (_ref) {
  var classes = _ref.classes,
    headers = _ref.headers,
    rows = _ref.rows;
  return /*#__PURE__*/React.createElement(MUITable, {
    className: classes.table,
    "aria-label": "simple table"
  }, headers && /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, headers.map(function (row, idx) {
    if (idx === 0) {
      return /*#__PURE__*/React.createElement(StyledTableCell, {
        key: "TC".concat(idx),
        dangerouslySetInnerHTML: {
          __html: row
        }
      });
    }
    return /*#__PURE__*/React.createElement(StyledTableCell, {
      align: "left",
      key: "TC".concat(idx),
      dangerouslySetInnerHTML: {
        __html: row
      }
    });
  }))), /*#__PURE__*/React.createElement(TableBody, null, rows.map(function (row, idx) {
    return /*#__PURE__*/React.createElement(StyledTableRow, {
      key: idx
    }, row.map(function (data, idx) {
      if (idx === 0) {
        return /*#__PURE__*/React.createElement(StyledTableCell, {
          component: "th",
          key: "STC-".concat(idx),
          scope: "row",
          dangerouslySetInnerHTML: {
            __html: data
          }
        });
      }
      return /*#__PURE__*/React.createElement(StyledTableCell, {
        align: "left",
        key: "STC-".concat(idx),
        dangerouslySetInnerHTML: {
          __html: data
        }
      });
    }));
  })));
});
function customStyles$1(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Table, props));
}
var StyledTabs = withStyles(function (theme) {
  return {
    root: {
      width: '100%',
      boxShadow: 'inset 0 -1px 0 0 #B3B6BC'
    },
    flexContainer: {
      display: 'block'
    },
    indicator: {
      backgroundColor: '#000',
      height: '3px'
    }
  };
})(MUITabs);
var StyledTabItems = withStyles(function (theme) {
  var _root;
  return {
    root: (_root = {
      minHeight: 53,
      minWidth: 80,
      padding: 'unset',
      margin: '0 12px',
      '& $wrapper': {
        textTransform: 'uppercase',
        fontSize: '14px'
      }
    }, _defineProperty(_root, theme.breakpoints.up('md'), {
      minWidth: 'unset'
    }), _defineProperty(_root, '&:hover', {
      '& $wrapper': {
        color: '#000'
      }
    }), _defineProperty(_root, '&$selected', {
      '& *': {
        color: '#000'
      }
    }), _root),
    selected: {},
    textColorInherit: {
      opacity: 1
    },
    wrapper: {
      textTransform: 'none',
      fontSize: 15,
      fontWeight: 700,
      color: '#DD271A'
    }
  };
})(Tab);
var Tabs = withStyles(function (theme) {
  return {
    root: {
      textAlign: 'left'
    },
    body: {
      margin: '40px 0',
      whiteSpace: 'pre-line'
    }
  };
}, {
  withTheme: true
})(function (_ref) {
  var classes = _ref.classes,
    data = _ref.data;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    tabIndex = _useState2[0],
    setTabIndex = _useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(StyledTabs, {
    variant: 'fullWidth',
    value: tabIndex,
    onChange: function onChange(e, index) {
      return setTabIndex(index);
    }
  }, data.map(function (_ref2, idx) {
    var _ref3 = _slicedToArray(_ref2, 1),
      title = _ref3[0];
    return /*#__PURE__*/React.createElement(StyledTabItems, {
      key: "ST-".concat(idx),
      label: title,
      disableRipple: true
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.body
  }, /*#__PURE__*/React.createElement(customStyles$a, {
    variant: "body1"
  }, data[tabIndex][1])), data[tabIndex][2] && /*#__PURE__*/React.createElement("div", {
    className: classes.table
  }, /*#__PURE__*/React.createElement("div", null, data[tabIndex][2])), data[tabIndex][3] && /*#__PURE__*/React.createElement("div", {
    className: classes.body
  }, /*#__PURE__*/React.createElement(customStyles$a, {
    variant: "body1"
  }, data[tabIndex][3])));
});
function customStyles(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Tabs, props));
}

/*!

=========================================================
* Material Kit PRO React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// ##############################
// // // Function that converts from hex color to rgb color
// // // Example: input = #9c27b0 => output = 156, 39, 176
// // // Example: input = 9c27b0 => output = 156, 39, 176
// // // Example: input = #999 => output = 153, 153, 153
// // // Example: input = 999 => output = 153, 153, 153
// #############################

var hexToRgb = function hexToRgb(input) {
  input = input + '';
  input = input.replace('#', '');
  var hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || input.length !== 3 && input.length !== 6) {
    throw new Error('input is not a valid hex color.');
  }
  if (input.length === 3) {
    var _first = input[0];
    var _second = input[1];
    var _last = input[2];
    input = _first + _first + _second + _second + _last + _last;
  }
  input = input.toUpperCase(input);
  var first = input[0] + input[1];
  var second = input[2] + input[3];
  var last = input[4] + input[5];
  return parseInt(first, 16) + ', ' + parseInt(second, 16) + ', ' + parseInt(last, 16);
}; // ##############################

var primaryColor = ['#DD271A',
// 500
'#eb4642',
// 400
'#e02524',
// 600
'#f92819',
//
'#ffc9cd',
// 100
'#e36a68' // 300
];

var warningColor = ['#ff9800', '#ffa726', '#fb8c00', '#ffa21a', '#fcf8e3', '#faf2cc', '#ffe0b2', '#ffb74d'];
var dangerColor = ['#f44336', '#ef5350', '#e53935', '#f55a4e', '#f2dede', '#ebcccc', 'ef9a9a', '#ef5350'];
var successColor = ['#4caf50', '#66bb6a', '#43a047', '#5cb860', '#dff0d8', '#d0e9c6', '#a5d6a7', '#66bb6a'];
var infoColor = ['#00acc1', '#26c6da', '#00acc1', '#00d3ee', '#d9edf7', '#c4e3f3', '#b2ebf2', '#4dd0e1'];
var roseColor = ['#e91e63', '#ec407a', '#d81b60', '#f8bbd0', '#f06292'];
var grayColor = ['#999', '#272A31', '#3C4858', '#eee', '#343434', '#585858', '#232323', '#ddd', '#6c757d', '#333', '#212121', '#777', '#D2D2D2', '#AAA', '#495057', '#e5e5e5', '#555', '#f9f9f9', '#ccc', '#444', '#f2f2f2', '#89229b', '#c0c1c2', '#9a9a9a', '#f5f5f5', '#505050', '#1f1f1f'];
var whiteColor = '#FFF';
var blackColor = '#000';
var containerFluid = {
  paddingRight: '15px',
  paddingLeft: '15px',
  marginRight: 'auto',
  marginLeft: 'auto',
  width: '100%'
};
var container = _objectSpread2(_objectSpread2({}, containerFluid), {}, {
  '@media (min-width: 576px)': {
    maxWidth: '540px'
  },
  '@media (min-width: 768px)': {
    maxWidth: '720px'
  },
  '@media (min-width: 992px)': {
    maxWidth: '960px'
  },
  '@media (min-width: 1200px)': {
    maxWidth: '1140px'
  }
});
({
  display: 'inline-block',
  position: 'relative',
  width: '100%',
  margin: '25px 0',
  boxShadow: '0 1px 4px 0 rgba(' + hexToRgb(blackColor) + ', 0.14)',
  borderRadius: '3px',
  color: 'rgba(' + hexToRgb(blackColor) + ', 0.87)',
  background: whiteColor
});
var defaultFont = {
  fontFamily: '"Raleway", "Arial", sans-serif',
  fontWeight: '400',
  lineHeight: '1.5em'
};
({
  boxShadow: '0 10px 30px -12px rgba(' + hexToRgb(blackColor) + ', 0.42), 0 4px 25px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(blackColor) + ', 0.2)'
});
var primaryBoxShadow = {
  boxShadow: '0 12px 20px -10px rgba(' + hexToRgb(primaryColor[0]) + ', 0.28), 0 4px 20px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 7px 8px -5px rgba(' + hexToRgb(primaryColor[0]) + ', 0.2)'
};
var infoBoxShadow = {
  boxShadow: '0 12px 20px -10px rgba(' + hexToRgb(infoColor[0]) + ', 0.28), 0 4px 20px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 7px 8px -5px rgba(' + hexToRgb(infoColor[0]) + ', 0.2)'
};
var successBoxShadow = {
  boxShadow: '0 12px 20px -10px rgba(' + hexToRgb(successColor[0]) + ', 0.28), 0 4px 20px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 7px 8px -5px rgba(' + hexToRgb(successColor[0]) + ', 0.2)'
};
var warningBoxShadow = {
  boxShadow: '0 12px 20px -10px rgba(' + hexToRgb(warningColor[0]) + ', 0.28), 0 4px 20px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 7px 8px -5px rgba(' + hexToRgb(warningColor[0]) + ', 0.2)'
};
var dangerBoxShadow = {
  boxShadow: '0 12px 20px -10px rgba(' + hexToRgb(dangerColor[0]) + ', 0.28), 0 4px 20px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 7px 8px -5px rgba(' + hexToRgb(dangerColor[0]) + ', 0.2)'
};
var roseBoxShadow = {
  boxShadow: '0 4px 20px 0px rgba(' + hexToRgb(blackColor) + ', 0.14), 0 7px 10px -5px rgba(' + hexToRgb(roseColor[0]) + ', 0.4)'
};
_objectSpread2({
  color: whiteColor,
  background: 'linear-gradient(60deg, ' + warningColor[1] + ', ' + warningColor[2] + ')'
}, warningBoxShadow);
_objectSpread2({
  color: whiteColor,
  background: 'linear-gradient(60deg, ' + successColor[1] + ', ' + successColor[2] + ')'
}, successBoxShadow);
_objectSpread2({
  color: whiteColor,
  background: 'linear-gradient(60deg, ' + dangerColor[1] + ', ' + dangerColor[2] + ')'
}, dangerBoxShadow);
_objectSpread2({
  color: whiteColor,
  background: 'linear-gradient(60deg, ' + infoColor[1] + ', ' + infoColor[2] + ')'
}, infoBoxShadow);
_objectSpread2({
  color: whiteColor,
  background: 'linear-gradient(60deg, ' + primaryColor[1] + ', ' + primaryColor[2] + ')'
}, primaryBoxShadow);
_objectSpread2({
  color: whiteColor,
  background: 'linear-gradient(60deg, ' + roseColor[1] + ', ' + roseColor[2] + ')'
}, roseBoxShadow);
_objectSpread2({
  margin: '0 20px 10px',
  paddingTop: '10px',
  borderTop: '1px solid  ' + grayColor[2],
  height: 'auto'
}, defaultFont);
({
  border: '0',
  borderRadius: '3px',
  boxShadow: '0 10px 20px -12px rgba(' + hexToRgb(blackColor) + ', 0.42), 0 3px 20px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(blackColor) + ', 0.2)',
  padding: '10px 0',
  transition: 'all 150ms ease 0s'
});
var title = {
  color: grayColor[1],
  textDecoration: 'none',
  fontWeight: '700',
  marginTop: '30px',
  marginBottom: '25px',
  minHeight: '32px',
  fontFamily: ['Raleway', 'Arial', 'sans-serif'].join(',')
};
({
  '&, & a': _objectSpread2(_objectSpread2({}, title), {}, {
    marginTop: '.625rem',
    marginBottom: '0.75rem',
    minHeight: 'auto'
  })
});
var main = {
  background: whiteColor,
  position: 'relative',
  zIndex: '3'
};
var mainRaised = {
  '@media (max-width: 576px)': {
    marginTop: '-30px'
  },
  '@media (max-width: 830px)': {
    marginLeft: '10px',
    marginRight: '10px'
  },
  margin: '-60px 30px 0px',
  borderRadius: '6px',
  boxShadow: '0 16px 24px 2px rgba(' + hexToRgb(blackColor) + ', 0.14), 0 6px 30px 5px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(blackColor) + ', 0.2)'
};
var parallaxStyle = {
  parallax: {
    height: '100vh',
    maxHeight: '1600px',
    overflow: 'hidden',
    position: 'relative',
    backgroundPosition: '50%',
    backgroundSize: 'cover',
    margin: '0',
    padding: '0',
    border: '0',
    display: 'flex',
    alignItems: 'center'
  },
  filter: {},
  primaryColor: {
    '&:before': {
      background: 'rgba(' + hexToRgb(blackColor) + ', 0.5)'
    },
    '&:after': {
      background: 'linear-gradient(60deg,rgba(' + hexToRgb(primaryColor[4]) + ',.56),rgba(' + hexToRgb(primaryColor[5]) + ',.95))'
    },
    '&:after,&:before': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: "''"
    }
  },
  roseColor: {
    '&:before': {
      background: 'rgba(' + hexToRgb(blackColor) + ', 0.5)'
    },
    '&:after': {
      background: 'linear-gradient(60deg,rgba(' + hexToRgb(roseColor[3]) + ',.56),rgba(' + hexToRgb(roseColor[4]) + ',.95))'
    },
    '&:after,&:before': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: "''"
    }
  },
  darkColor: {
    '&:before': {
      background: 'rgba(' + hexToRgb(blackColor) + ', 0.5)'
    },
    '&:after,&:before': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: "''"
    }
  },
  infoColor: {
    '&:before': {
      background: 'rgba(' + hexToRgb(blackColor) + ', 0.5)'
    },
    '&:after': {
      background: 'linear-gradient(60deg,rgba(' + hexToRgb(infoColor[6]) + ',.56),rgba(' + hexToRgb(infoColor[7]) + ',.95))'
    },
    '&:after,&:before': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: "''"
    }
  },
  successColor: {
    '&:before': {
      background: 'rgba(' + hexToRgb(blackColor) + ', 0.5)'
    },
    '&:after': {
      background: 'linear-gradient(60deg,rgba(' + hexToRgb(successColor[6]) + ',.56),rgba(' + hexToRgb(successColor[7]) + ',.95))'
    },
    '&:after,&:before': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: "''"
    }
  },
  warningColor: {
    '&:before': {
      background: 'rgba(' + hexToRgb(blackColor) + ', 0.5)'
    },
    '&:after': {
      background: 'linear-gradient(60deg,rgba(' + hexToRgb(warningColor[6]) + ',.56),rgba(' + hexToRgb(warningColor[7]) + ',.95))'
    },
    '&:after,&:before': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: "''"
    }
  },
  dangerColor: {
    '&:before': {
      background: 'rgba(' + hexToRgb(blackColor) + ', 0.5)'
    },
    '&:after': {
      background: 'linear-gradient(60deg,rgba(' + hexToRgb(dangerColor[6]) + ',.56),rgba(' + hexToRgb(dangerColor[7]) + ',.95))'
    },
    '&:after,&:before': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: "''"
    }
  },
  small: {
    height: '65vh',
    minHeight: '65vh',
    maxHeight: '650px'
  }
};
var useStyles$3 = makeStyles(parallaxStyle);
function Parallax(props) {
  var _classNames;
  var windowScrollTop;
  if (window.innerWidth >= 768) {
    windowScrollTop = window.pageYOffset / 3;
  } else {
    windowScrollTop = 0;
  }
  var _React$useState = React.useState('translate3d(0,' + windowScrollTop + 'px,0)'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    transform = _React$useState2[0],
    setTransform = _React$useState2[1];
  React.useEffect(function () {
    if (window.innerWidth >= 768) {
      window.addEventListener('scroll', resetTransform);
    }
    return function cleanup() {
      if (window.innerWidth >= 768) {
        window.removeEventListener('scroll', resetTransform);
      }
    };
  });
  var resetTransform = function resetTransform() {
    var windowScrollTop = window.pageYOffset / 3;
    setTransform('translate3d(0,' + windowScrollTop + 'px,0)');
  };
  var filter = props.filter,
    className = props.className,
    children = props.children,
    style = props.style,
    image = props.image,
    small = props.small;
  var classes = useStyles$3();
  var parallaxClasses = classNames((_classNames = {}, _defineProperty(_classNames, classes.parallax, true), _defineProperty(_classNames, classes[filter + 'Color'], filter !== undefined), _defineProperty(_classNames, classes.small, small), _defineProperty(_classNames, className, className !== undefined), _classNames));
  return /*#__PURE__*/React.createElement("div", {
    className: parallaxClasses,
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      backgroundImage: 'url(' + image + ')',
      transform: transform
    })
  }, children);
}
var landingPageStyle = {
  topContainer: {
    height: '415px',
    '@media (min-width: 450px)': {
      height: '515px'
    },
    overflow: 'hidden',
    position: 'relative'
  },
  container: _objectSpread2(_objectSpread2({
    color: blackColor
  }, container), {}, {
    zIndex: '2'
  }),
  pow: {
    height: '1000px',
    backgroundColor: whiteColor,
    zIndex: 1,
    position: 'relative'
  },
  title: _objectSpread2(_objectSpread2({}, title), {}, {
    display: 'inline-block',
    position: 'relative',
    marginTop: '30px',
    minHeight: '32px',
    color: whiteColor,
    textDecoration: 'none'
  }),
  subtitle: {
    fontSize: '1.313rem',
    maxWidth: '500px',
    margin: '10px auto 0'
  },
  main: _objectSpread2({}, main),
  mainRaised: _objectSpread2(_objectSpread2({}, mainRaised), {}, {
    borderRadius: 0,
    position: 'absolute',
    bottom: 0,
    '@media (min-width: 1200px)': {
      marginLeft: 'calc((100vw - 1170px) / 2)'
    }
  }),
  block: {
    color: 'inherit',
    padding: '0.9375rem',
    fontWeight: '500',
    fontSize: '12px',
    textTransform: 'uppercase',
    borderRadius: '3px',
    textDecoration: 'none',
    position: 'relative',
    display: 'block'
  },
  inlineBlock: {
    display: 'inline-block',
    padding: '0px',
    width: 'auto'
  },
  list: {
    marginBottom: '0',
    padding: '0',
    marginTop: '0'
  },
  left: {
    "float": 'left!important',
    display: 'block'
  },
  right: {
    padding: '15px 0',
    margin: '0',
    "float": 'right'
  },
  icon: {
    width: '18px',
    height: '18px',
    top: '3px',
    position: 'relative'
  },
  heading: {
    fontSize: 70,
    fontWeight: 700,
    margin: 0,
    lineHeight: 1.4,
    '@media (max-width:960px)': {
      fontSize: 48
    }
  },
  profileContainer: {
    height: '650px',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex'
  },
  profileBanner: {
    height: '220px',
    margin: 'auto 0',
    width: '100%',
    backgroundColor: 'black',
    display: 'flex',
    '@media (max-width: 900px)': {
      height: '420px',
      margin: 'auto 0 0 0'
    },
    '@media (max-width: 325px)': {
      height: '435px'
    }
  },
  profileWrap: {
    display: 'flex',
    margin: '0 auto',
    '@media (max-width: 900px)': {
      flexDirection: 'column'
    }
  },
  profileImgWrap: {
    position: 'relative',
    width: '350px',
    color: 'white',
    '@media (max-width: 900px)': {
      height: '350px',
      width: '100%'
    },
    '& img': {
      position: 'absolute',
      width: '350px',
      height: '350px',
      top: '-65px',
      '@media (max-width: 900px)': {
        top: '-175px',
        left: '50%',
        transform: 'translateX(-50%)'
      }
    }
  },
  profileContent: {
    color: 'white',
    padding: '1.5rem 0 1.5rem 2.15rem',
    width: '38rem',
    '& h4': {
      margin: '0.3rem 0'
    },
    '& a': {
      color: '#DD271A',
      borderBottomColor: '#DD271A',
      textDecoration: 'unset',
      textTransform: 'uppercase',
      borderBottom: '2px solid red',
      fontWeight: '700',
      fontSize: '1rem',
      '&:hover': {
        textDecoration: 'unset'
      }
    },
    '@media (max-width: 900px)': {
      width: '24rem',
      padding: '0.25rem 2.15rem 2.5rem',
      textAlign: 'center',
      '& h3': {
        textAlign: 'center !important'
      }
    },
    '@media (max-width: 460px)': {
      width: 'unset'
    }
  },
  sectionHeaderContainer: {
    height: 'auto',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& img': {
      height: '320px',
      width: '100%',
      objectFit: 'cover'
    },
    '& a': {
      color: '#EE3224',
      borderBottomColor: '#EE3224',
      textDecoration: 'unset',
      textTransform: 'uppercase',
      borderBottom: '2px solid red',
      fontWeight: '700',
      fontSize: '12px',
      letterSpacing: '1.5px',
      '&:hover': {
        textDecoration: 'unset'
      }
    }
  },
  sectionHeaderContent: {
    position: 'relative',
    backgroundColor: 'white',
    textAlign: 'center',
    padding: '1rem'
  },
  sectionHeaderContentWrapper: {
    position: 'relative',
    fontSize: '32px',
    fontWeight: 'bold',
    backgroundColor: 'white',
    padding: '1.25rem 4.5rem',
    lineHeight: '1',
    '@media (max-width: 1024px)': {
      fontSize: '28px',
      padding: '1.25rem 3rem'
    },
    '@media (max-width: 768px)': {
      fontSize: '24px',
      padding: '1.25rem 1.25rem'
    },
    '@media (max-width: 460px)': {
      fontSize: '24px',
      padding: '1rem 1.25rem'
    },
    '@media (max-width: 350px)': {
      fontSize: '22px'
    }
  },
  sectionHeaderTitle: {
    position: 'relative',
    backgroundColor: 'white',
    padding: '1.25rem 2rem',
    marginTop: '-5rem',
    fontSize: 'inherit',
    display: 'block',
    minWidth: 'fit-content',
    marginLeft: 'auto',
    marginRight: 'auto',
    '&::before': {
      content: '""',
      position: 'absolute',
      width: '90px',
      backgroundColor: '#EE3224',
      height: '3.5px',
      top: '0',
      left: '50%',
      transform: 'translateX(-50%)'
    }
  },
  dark: {
    backgroundColor: '#101319',
    '& h1': {
      color: '#fff'
    }
  }
};

/*eslint-disable*/
var useStyles$2 = makeStyles(landingPageStyle);
function Hero(_ref) {
  var backgroundImage = _ref.backgroundImage,
    title = _ref.title,
    variant = _ref.variant;
  var classes = useStyles$2();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.topContainer
  }, /*#__PURE__*/React.createElement(Parallax, {
    image: backgroundImage,
    filter: "dark"
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.main, classes.mainRaised, variant === 'dark' ? classes.dark : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("h1", {
    className: classes.heading
  }, title))));
}

/*eslint-disable*/
var useStyles$1 = makeStyles(landingPageStyle);
function Profile(_ref) {
  var profileImage = _ref.profileImage,
    imgAlt = _ref.imgAlt,
    title = _ref.title,
    backgroundColor = _ref.backgroundColor,
    desc = _ref.desc,
    job = _ref.job,
    name = _ref.name,
    btnTxt = _ref.btnTxt,
    link = _ref.link;
  var classes = useStyles$1();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.profileContainer,
    style: {
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.profileBanner
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.profileWrap
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.profileImgWrap
  }, /*#__PURE__*/React.createElement("img", {
    src: profileImage,
    alt: imgAlt,
    loading: "lazy"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.profileContent
  }, /*#__PURE__*/React.createElement("h3", null, title), /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement("span", null, name), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, job)), /*#__PURE__*/React.createElement("p", null, desc), /*#__PURE__*/React.createElement("a", {
    href: link
  }, btnTxt)))));
}

/*eslint-disable*/
var useStyles = makeStyles(landingPageStyle);
function SectionHeader(_ref) {
  var _file$asset;
  var headerImg = _ref.headerImg,
    imgAlt = _ref.imgAlt,
    title = _ref.title,
    children = _ref.children,
    file = _ref.file,
    linkTxt = _ref.linkTxt,
    link = _ref.link;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.sectionHeaderContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: headerImg,
    alt: imgAlt,
    loading: "lazy"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.sectionHeaderContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.sectionHeaderContentWrapper
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.sectionHeaderTitle
  }, title), /*#__PURE__*/React.createElement("div", {
    className: classes.sectionHeaderContentBlock
  }, /*#__PURE__*/React.createElement(customStyles$a, {
    variant: "body1",
    color: "textSecondary"
  }, children)), /*#__PURE__*/React.createElement("a", {
    href: link ? link : file === null || file === void 0 ? void 0 : (_file$asset = file.asset) === null || _file$asset === void 0 ? void 0 : _file$asset.url,
    title: title,
    target: link ? '' : '_blank'
  }, linkTxt))));
}
export { customStyles$9 as Accordion, customStyles$8 as Button, customStyles$7 as Card, customStyles$6 as CardGrid, customStyles$5 as Carousel, Hero, customStyles$4 as ImageGrid, customStyles$3 as Link, customStyles$2 as Pagination, Profile, SectionHeader, customStyles$1 as Table, customStyles as Tabs, customStyles$a as Typography };